var _ellipse, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 23.5,
    rx: 23.5,
    ry: 23.5,
    transform: "rotate(90 23.5 23.5)",
    fill: "#2CADE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5839 23.0335C18.5839 22.7564 18.6859 22.4793 18.9047 22.2605C19.3276 21.8376 20.0276 21.8376 20.4505 22.2605L23.4109 25.221L26.3714 22.2605C26.7943 21.8376 27.4943 21.8376 27.9172 22.2605C28.3401 22.6835 28.3401 23.3835 27.9172 23.8064L24.1839 27.5397C23.7609 27.9626 23.0609 27.9626 22.638 27.5397L18.9047 23.8064C18.6859 23.6022 18.5839 23.3105 18.5839 23.0335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3203 26.6643L22.3203 11.833C22.3203 11.2351 22.8161 10.7393 23.4141 10.7393C24.012 10.7393 24.5078 11.2351 24.5078 11.833L24.5078 26.6643C24.5078 27.2622 24.012 27.758 23.4141 27.758C22.8161 27.758 22.3203 27.2622 22.3203 26.6643Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7409 23.5C10.7409 22.9021 11.2367 22.4062 11.8346 22.4062C12.4326 22.4062 12.9284 22.9021 12.9284 23.5C12.9284 29.7271 17.2742 34.0729 23.5013 34.0729C29.7284 34.0729 34.0742 29.7271 34.0742 23.5C34.0742 22.9021 34.5701 22.4062 35.168 22.4062C35.7659 22.4062 36.2617 22.9021 36.2617 23.5C36.2617 31.0104 31.0117 36.2604 23.5013 36.2604C15.9909 36.2604 10.7409 31.0104 10.7409 23.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCircle);
export default __webpack_public_path__ + "static/media/importCircle.e1393dbe8ed19640eb6815c5db8f84db.svg";
export { ForwardRef as ReactComponent };